import { useInjection } from "@linkfluence/core/di";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  InsightPage,
  RecurringSnapshotPayload,
} from "@radarly/models/insight-pages/model";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
} from "../repositories/InsightPageRepo";

export function useSendRecurringSnapshot() {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, isError, isSuccess, reset, data } =
    useMutation(
      ({
        project,
        id,
        snapshot,
      }: {
        project: number;
        id: InsightPage["id"];
        snapshot: RecurringSnapshotPayload;
      }) => {
        return repository.sendRecurringSnapshot(project, id, snapshot);
      },
      {
        onSuccess: (snapshot, { project, id }) => {
          queryClient.invalidateQueries([
            "/recurring-snapshots/list",
            {
              project,
              id,
            },
          ]);
        },
      }
    );
  const sendRecurringSnapshot = (data: {
    project: number;
    id: InsightPage["id"];
    snapshot: RecurringSnapshotPayload;
  }) => {
    return mutateAsync(data);
  };
  return {
    sendRecurringSnapshot,
    loading: isLoading,
    error: isError,
    success: isSuccess,
    recurringSnapshot: data,
    reset: () => reset(),
  };
}
